import React, { Component } from 'react';
import ModalMaterial from '../../../../materials/ModalMaterial';
import SpinMaterial from '../../../../materials/SpinMaterial';
import FormVersionMobileComponent, { FormVersionMobileType } from './FormVersionMobileComponent';

interface IProps {
  visible: any;
  jenisToggle: any;
  isLoading: any;
  isView?: boolean;
  handleChange: (name: string, value: any) => void;
  handleClear: () => void;
  initialData: FormVersionMobileType;
  handleSubmit?: () => void;
}

export default class AddVersionMobileComponent extends Component<IProps> {
  render() {
    return (
      <div>
        <ModalMaterial
          className={''}
          width={'80%'}
          style={{}}
          teksTitle={'TAMBAH VERSI'}
          visible={
            this.props.jenisToggle === 'AddVersionMobile' && this.props.visible === true
              ? true
              : false
          }
          onCancel={this.props.handleClear}
          content={
            <SpinMaterial
              spinning={this.props.isLoading}
              style={{}}
              size={'large'}
              content={<FormVersionMobileComponent {...this.props} />}
            />
          }
        />
      </div>
    );
  }
}
